import {
  createPlugin,
  createApiFactory,
  createComponentExtension,
  discoveryApiRef,
  identityApiRef,
} from "@backstage/core-plugin-api";
import { Entity } from "@backstage/catalog-model";
import {
  CONFLUENCE_QUERY_ANNOTATION,
  CONFLUENCE_USER_ID_ANNOTATION,
} from "./hooks";
import { confluenceApiRef, ConfluenceApi } from "./api/ConfluenceApi";
import { rootRouteRef } from "./routes";

export const confluenceApiPlugin = createPlugin({
  id: "confluence-api",
  apis: [
    createApiFactory({
      api: confluenceApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new ConfluenceApi({
          discoveryApi,
          identityApi,
        }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const EntityConfluenceContent = confluenceApiPlugin.provide(
  createComponentExtension({
    component: {
      lazy: () => import("./views/EntityPanel").then((m) => m.EntityPanel),
    },
  })
);

export const UserConfluenceContent = confluenceApiPlugin.provide(
  createComponentExtension({
    component: {
      lazy: () => import("./views/UserPanel").then((m) => m.UserPanel),
    },
  })
);

export const isConfluenceAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[CONFLUENCE_QUERY_ANNOTATION]);

export const isConfluenceUserAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[CONFLUENCE_USER_ID_ANNOTATION]);
